import { Tag } from 'antd';
import styled from 'styled-components';

export const ClickableTag = styled(Tag)`
  cursor: pointer;
`;
